import {
  GET_Field_VOCABULARY_RECORDS,
  GET_Field_VOCABULARY_SUCCESS,
  GET_Field_VOCABULARY_ERROR,
} from "../actions";

export const getVocabularyRecords = () => {
  return {
    type: GET_Field_VOCABULARY_RECORDS,
    payload: {},
  };
};

export const getVocabularyRecordsSuccess = (recordList) => ({
  type: GET_Field_VOCABULARY_SUCCESS,
  payload: recordList,
});

export const getVocabularyRecordsError = (message) => ({
  type: GET_Field_VOCABULARY_ERROR,
  payload: { message },
});

